'use es6';

import { Map as ImmutableMap } from 'immutable';
import { FETCH_CONTENT_SCHEMA_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
const ampReducer = (state = ImmutableMap(), {
  type,
  response
}) => {
  switch (type) {
    case FETCH_CONTENT_SCHEMA_SUCCEEDED:
      {
        const {
          content: {
            parentBlog
          }
        } = response;
        return state.merge({
          enableGoogleAmpOutput: parentBlog.enableGoogleAmpOutput
        });
      }
    default:
      return state;
  }
};
export default ampReducer;